/** Sonner duration (ms) for export-ready realtime toast — long-lived so users can click Download when ready. */
export const EXPORT_READY_TOAST_DURATION_MS = 86_400_000; // 24 hours
